import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { destinoDoAtalhoManual } from "@/lib/atalho-de-etiquetas";
import { cn } from "@/lib/cn";

const PASSOS = [
  "Clique com o botão direito na área de trabalho e escolha Novo › Atalho.",
  "Cole o texto acima no campo do local do item e clique em Avançar.",
  "Dê o nome \"DentalBook Etiquetas\" e clique em Concluir.",
  "Para abrir sozinho quando o computador ligar: copie o atalho, aperte Windows + R, digite shell:startup e cole na pasta que abrir.",
];

/** Plano B do instalador: quando o antivírus barra o .cmd, o atalho feito à mão, sem baixar nada. */
export function AtalhoManual() {
  const [navegador, setNavegador] = useState<"chrome" | "edge">("chrome");
  const [copiado, setCopiado] = useState(false);
  const texto = destinoDoAtalhoManual(navegador, window.location.origin);
  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(texto);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      toast.error("Não foi possível copiar. Selecione o texto e copie com Ctrl + C.");
    }
  };

  return (
    <div className="space-y-2.5 border-t border-zinc-100 px-3 py-2.5 text-[12px] text-zinc-600 dark:border-border dark:text-muted-foreground">
      <div className="flex gap-1">
        {(
          [
            ["chrome", "Google Chrome"],
            ["edge", "Microsoft Edge"],
          ] as const
        ).map(([chave, rotulo]) => (
          <button
            key={chave}
            type="button"
            onClick={() => setNavegador(chave)}
            className={cn(
              "h-7 rounded-md border px-2.5 text-[12px] font-semibold transition-colors",
              navegador === chave
                ? "border-brand-600 bg-brand-50 text-brand-700 dark:bg-primary/10 dark:text-primary"
                : "border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50 dark:border-border dark:bg-card dark:text-foreground",
            )}
          >
            {rotulo}
          </button>
        ))}
      </div>
      <div className="flex items-start gap-2">
        <code className="min-w-0 flex-1 select-all break-all rounded-md border border-zinc-200 bg-zinc-50 px-2 py-1.5 font-mono text-[11px] text-zinc-800 dark:border-border dark:bg-muted dark:text-foreground">
          {texto}
        </code>
        <button
          type="button"
          onClick={copiar}
          className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-md border border-zinc-200 bg-white px-2.5 text-[12px] font-semibold text-zinc-700 transition-colors hover:bg-zinc-50 dark:border-border dark:bg-card dark:text-foreground dark:hover:bg-muted"
        >
          {copiado ? <Check className="h-3.5 w-3.5 text-emerald-600" /> : <Copy className="h-3.5 w-3.5" />}
          {copiado ? "Copiado" : "Copiar"}
        </button>
      </div>
      <ol className="list-decimal space-y-1 pl-5">
        {PASSOS.map((p) => (
          <li key={p}>{p}</li>
        ))}
        <li>
          Opcional, com o ícone do DentalBook:{" "}
          <a href="/dentalbook.ico" download="DentalBook.ico" className="font-semibold text-brand-600 hover:underline dark:text-primary">
            baixe o ícone
          </a>
          , clique com o botão direito no atalho › Propriedades › Alterar ícone › Procurar e escolha o arquivo baixado (não apague o arquivo depois).
        </li>
      </ol>
    </div>
  );
}
